import { green, grey } from '@mui/material/colors';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Layout from './layout/Layout';
import { UserProvider } from './pages/login/UserContextPersistent';
import { LocalizedTagProvider } from './context/LocalizedTagContext';
import { SettingsProvider } from './context/SettingsContext';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import KalravProvider from './contexts/KalravProvider';
import { KalravWidget } from '@irisidea/kalrav-ai/react';
import { shouldTrackAnalytics, trackPageView } from './lib/analytics';

const theme = createTheme({
  palette: {
    primary: {
      main: grey[900],
    },
    secondary: {
      main: green[500],
    },
  },
});

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!shouldTrackAnalytics(location.pathname)) {
      return;
    }

    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider theme={theme}>
        {/* <KalravProvider> */}
          {/* <KalravWidget 
            apiKey="yTnED9puNwpt6Mrxz1tQdhdwnslIV8wgs8uZL915pUA"
            agentId="agent_d9ad8380cb790665"
          /> */}
          <SettingsProvider>
            <LocalizedTagProvider>
              <UserProvider>
                <Router>
                  <AnalyticsTracker />
                  <Layout />
                </Router>
              </UserProvider>
            </LocalizedTagProvider>
          </SettingsProvider>
        {/* </KalravProvider> */}
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
